module.exports = __webpack_public_path__ + "static/media/sozidanie.25301482.jpg";